import React from "react";
import { useSelector } from "react-redux";
import { selectTableData } from "./cashback-selectors";
import {
  Container,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { H6, Icone } from "../../../components";
import {
  convertItemToObject,
  getLabelStatusCashback,
  getStatusCashback,
} from "./cashback-utils";

const STR = {
  title: "Detalhes sobre o cashback",
  labelClientName: "Nome do cliente",
  labelCashbackValue: "Valor do cashback",
  labelValueSale: "Valor da venda",
  labelDateSend: "Data de envio",
  labelDeadline: "Prazo para resgate",
  labelStatus: "Status",
  labelStore: "Loja",
  labelCellphone: "Celular",
};

const onRegisterSelected = (id, registers) => {
  return registers.filter((register) => register.id === id);
};

function CashbackDetailsView({ id }) {
  const dataBody = useSelector(selectTableData);
  let register = onRegisterSelected(id, dataBody);
  if (!register || register.length === 0) return null;

  register = convertItemToObject(register[0].data);

  const details = [
    { icon: "Person", label: STR.labelClientName, value: register.nameClient },
    {
      icon: "CardGiftcard",
      label: STR.labelCashbackValue,
      value: register.valueVoucher,
    },
    { icon: "Paid", label: STR.labelValueSale, value: register.valueSale },
    {
      icon: "CalendarToday",
      label: STR.labelDateSend,
      value: register.dateSend,
    },
    {
      icon: "CalendarMonth",
      label: STR.labelDeadline,
      value: register.datePraz,
    },

    {
      icon: getStatusCashback(register.status),
      label: STR.labelStatus,
      value: getLabelStatusCashback(register.status),
    },
    { icon: "Store", label: STR.labelStore, value: register.store },
    { icon: "WhatsApp", label: STR.labelCellphone, value: register.cellPhone },
  ];

  return (
    <Container maxWidth={false}>
      <H6>{STR.title}</H6>
      <List>
        {details.map((detail, index) => (
          <ListItem key={index}>
            <ListItemIcon>
              <Icone icone={detail.icon} />
            </ListItemIcon>
            <ListItemText primary={detail.label} secondary={detail.value} />
          </ListItem>
        ))}
      </List>
    </Container>
  );
}

export default CashbackDetailsView;
